import Vue from 'vue'
import Vuetify from 'vuetify'
import './stylus/main.styl'
import App from './App'
import * as firebase from 'firebase'
import {store} from "./store/store"
import router from './router'
Vue.use(Vuetify)

Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  store,
  router,
  created(){
    firebase.initializeApp({
      apiKey: "AIzaSyCTyDUcM6MxCnyFRzfUNXi8ee8GQQVcxbM",
      authDomain: "driewekenplanning.firebaseapp.com",
      databaseURL: "https://driewekenplanning.firebaseio.com",
      projectId: "driewekenplanning",
      storageBucket: "driewekenplanning.appspot.com"
    })
  }
})



// WEBPACK FOOTER //
// ./src/main.js